

















import {
  defineComponent,
  ComputedRef,
  computed,
  ref
} from '@vue/composition-api';
import {
  Dga,
  PieChart,
  PreviewDocuments,
  UpsellPackages,
  ShareholderInformation,
  HoldingUpsell,
  GenericSections,
  ContractUpsell,
  ExtraServices
} from '../shared-steps';
import { useSteps } from './handler.hooks';
import { NotaryProduct } from '@ligo/bv-flow/store';
import { paymentRedirect } from '../tools/payment_redirection';
import { reloadPage, endStep } from '../tools/utils';
import Vue from 'vue';
export default defineComponent({
  name: 'EnglishBVHandler',
  components: {
    GenericSections,
    ShareholderInformation,
    PieChart,
    HoldingUpsell,
    ContractUpsell,
    ExtraServices,
    UpsellPackages,
    Dga,
    PreviewDocuments
  },
  props: {
    notary_product: {
      type: Object as () => NotaryProduct,
      required: true
    }
  },
  setup(props, { root }) {
    const loading = ref(false);
    const router = Vue['Router'];
    const currentStep: ComputedRef<number> = computed(() => {
      return props.notary_product.temporalStep;
    });
    props.notary_product.setStepBounds();
    const { steps } = useSteps(props.notary_product);
    const stepToShow: ComputedRef = computed(() => {
      paymentRedirect(currentStep, props.notary_product, root);
      return steps[currentStep.value];
    });

    const endedStep = () => {
      endStep(currentStep, props.notary_product, root);
      reload();
    };

    const reload = () => {
      reloadPage(loading, root, props.notary_product);
    };

    const transferToOmzetting = () => {
      router
        .push({
          name: 'Omzetting'
        })
        .then(() => {
          window.location.reload();
        });
    };
    return { endedStep, stepToShow, loading, reload, transferToOmzetting };
  }
});
